import { combineEpics } from 'redux-observable';
import { rootEpic as ComputeListEpic } from './views/ComputeList/epics';
import { rootEpic as ComputeDetailEpic } from './views/ComputeDetail/epics';
import { rootEpic as ComputeCreateEpic } from './views/ComputeCreate/epics';
import { getComputeEpicReducer } from './ducks/GetCompute.ducks';
import { getComputeListEpicReducer } from './ducks/GetComputeList.ducks';
import { deleteComputeEpicReducer } from './ducks/DeleteCompute.ducks';
import { putComputeEpicReducer } from './ducks/PutCompute.ducks';
export const rootEpic = combineEpics(ComputeListEpic, ComputeDetailEpic, ComputeCreateEpic, getComputeEpicReducer.epic, getComputeListEpicReducer.epic, deleteComputeEpicReducer.epic, putComputeEpicReducer.epic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
